import { Building2, Factory, Plane, Wheat, Zap, Sailboat, Network, ArrowRight } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fmtR } from "@/lib/format";

export const THEME_ICONS = { urban: Building2, industrial: Factory, aviation: Plane, agri: Wheat, energy: Zap, tourism: Sailboat, social: Network };

export const OppCard = ({ opp, onClick, active, testid, cta }) => {
  const { themes } = useApp();
  const t = themes[opp.theme];
  const Icon = THEME_ICONS[opp.theme];
  return (
    <button data-testid={testid || `opp-card-${opp.id}`} onClick={onClick}
      className={`group relative w-full overflow-hidden rounded-lg border text-left transition-[transform,border-color] duration-300 hover:-translate-y-1 ${active ? "border-[#F4B842]" : "border-slate-500/25 hover:border-slate-300/50"} bg-[#0B1F38]`}>
      <div className="relative h-28 overflow-hidden">
        <img src={opp.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
        <span className="absolute bottom-2 left-2 rounded px-1.5 py-0.5 text-[10px] font-extrabold uppercase" style={{ background: t?.color, color: "#06142A" }}>{t?.short}</span>
        <span className="absolute right-2 top-2 rounded bg-black/55 px-1.5 py-0.5 text-[9px] uppercase tracking-wider text-slate-200">Illustrative</span>
      </div>
      <div className="flex items-start gap-2.5 p-3">
        {Icon && <Icon className="mt-0.5 h-5 w-5 shrink-0 text-slate-300" strokeWidth={1.5} />}
        <div className="min-w-0 flex-1">
          <div className="truncate text-[13.5px] font-semibold text-white">{opp.name}</div>
          <div className="mt-1 text-[12px] text-slate-300">{opp.area_ha} ha <span className="text-slate-500">|</span> {fmtR(opp.capex_m)} <span className="text-[10px] text-purple-300">synthetic</span></div>
          {cta && <div className="mt-2 text-[12px] font-semibold text-[#F4B842]">{cta}</div>}
        </div>
        <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full border border-slate-300/50 transition-colors group-hover:border-[#F4B842] group-hover:text-[#F4B842]"><ArrowRight className="h-3.5 w-3.5" /></span>
      </div>
    </button>
  );
};

export const ThemeCard = ({ theme, onClick, active, testid }) => {
  const Icon = THEME_ICONS[theme.id];
  return (
    <button data-testid={testid} onClick={onClick} className={`group overflow-hidden rounded-lg border bg-[#0B1F38]/90 text-left transition-[transform,border-color] duration-300 hover:-translate-y-1 ${active ? "border-[#F4B842]" : "border-slate-500/25 hover:border-slate-300/50"}`}>
      <div className="h-28 overflow-hidden"><img src={theme.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" /></div>
      <div className="flex gap-3 p-3.5">
        {Icon && <Icon className="mt-0.5 h-6 w-6 shrink-0 text-slate-200" strokeWidth={1.4} />}
        <div>
          <div className="text-[14px] font-semibold text-white">{theme.name}</div>
          <div className="mt-1 line-clamp-2 text-[11.5px] leading-snug text-slate-400">{theme.validation}</div>
          <div className="mt-2 flex items-center gap-1 text-[12px] font-semibold text-[#F4B842]">View Opportunities <ArrowRight className="h-3.5 w-3.5" /></div>
        </div>
      </div>
    </button>
  );
};
